import { FunctionComponent, cloneElement } from 'react'

import { Stack, Typography } from '@mui/material'

import { Button } from './Button';
import { Card, CardContent } from './card';
import { useScreenSize } from '@dw/hooks';

interface IEmptyListCTAProps {
  icon: React.ReactNode;
  body: string;
  ctaText?: string;
  ctaHelperText?: string;
  ctaClicked?: () => void;
  ctaRouterLink?: string;
  ctaLoading?: boolean;
  useCardWrapper?: boolean;
}
export const EmptyListCTA: FunctionComponent<IEmptyListCTAProps> = (props: IEmptyListCTAProps) => {

  const {
    icon,
    body,
    ctaText,
    ctaHelperText,
    ctaClicked,
    ctaRouterLink,
    ctaLoading,
    useCardWrapper
  } = props;

  const { isMobile } = useScreenSize();

  const getIcon = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return cloneElement(icon as any, {
      color: 'textColor',
      sx: {
        fontSize: 80
      }
    });
  }

  const mainBody = (
    <Stack justifyContent='center' alignItems='center' flexDirection='column' rowGap={3} padding={isMobile ? 1 : 8}>
      {getIcon()}
      <Typography variant='h5' textAlign='center'>
        {body}
      </Typography>
      {
        ctaText && (
          <Button onClick={ctaClicked} routerLink={ctaRouterLink} loading={ctaLoading}>
            {ctaText}
          </Button>
        )
      }
      {
        ctaHelperText && (
          <Typography variant='caption' textAlign='center' sx={{
            whiteSpace: 'break-spaces'
          }}>{ctaHelperText}</Typography>
        )
      }
    </Stack>
  );

  if (useCardWrapper) {
    return (
      <Card>
        <CardContent>
          {mainBody}
        </CardContent>
      </Card>
    )
  }

  return mainBody;
}